import { useEffect, useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import {
  USER_TAB_TYPE,
  GROUP_TAB_TYPE,
  APPLICATION_TAB_TYPE,
  exportListFileName,
  exportListHeaders,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_SKILL_STREAM_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
} from "../../constant/constants";
import { CircleLoading, DownloadIcon, FilterIcon } from "../../Icons";
import { checkPermissionExist, downloadExcel, downloadPdf, exportFormatData, toggleArrayByObject } from "../../utils/general";
import { GROUP_DETAILS, GROUP_LIST, GROUP_USERS_LIST } from "../../apiClient/apiEndpoints";
import apiClient from "../../apiClient";
import GroupContent from "../SectionContent/GroupContent";
import UserContent from "../SectionContent/UserContent";
import ApplicationContent from "../SectionContent/ApplicationContent";
import { useSelector } from "react-redux";
import { GROUP_VIEW_PERMISSION, RESOURCE_VIEW_PERMISSION, USER_VIEW_PERMISSION } from "../../constant/permission";
import FilterOption from "../filteroption";
import useDebounce from "../../hooks/useDebounce";

const { BackButton, SearchBar, TabNavigator } = UiComponents;
let initialSearch = {
  [GROUP_TAB_TYPE]: "",
  [USER_TAB_TYPE]: "",
  [APPLICATION_TAB_TYPE]: "",
}

const SectionNavigation = ({
  showfilter, defaultTab, setDefaultTab,
  setShowFilter, activeTab, setActiveTab,
  UUID, UNO_URL, setCurrentTab, refreshTab,
  isMobileView,
  applicationSelectedCheckboxes,
  setApplicationSelectedCheckboxes,
  groupSelectedCheckboxes,
  setGroupSelectedCheckboxes,
  userSelectedCheckboxes,
  setUserSelectedCheckboxes,
}) => {
  const { searchValue } = useSelector(state => state.searchSlice);
  const filterOptions = useSelector(state => state.filterOptions);
  const [pdfDownload, setPdfDownload] = useState(false);

  const [search, setSearch] = useState({...initialSearch});

  useEffect(() => {
    if (setCurrentTab) setCurrentTab(activeTab);
  }, [activeTab]);

  useEffect(() => {
    setSearch((pre) => ({ ...pre, [activeTab]: searchValue }))
  }, [searchValue]);

  useEffect(() => {
    const fromPreviousUserTab = localStorage.getItem("prevTabHistory");
    if (fromPreviousUserTab) {
      setActiveTab(fromPreviousUserTab);
      localStorage.removeItem("prevTabHistory")
    }
    setSearch({...initialSearch});
  }, [UUID]);

  const openFilter = () => {
    setShowFilter((prev) => !prev);
  };

  const handleClickDownload = async () => {
    try {
      setPdfDownload(true);

      const fetchList = {
        [USER_TAB_TYPE]: GROUP_USERS_LIST,
        [GROUP_TAB_TYPE]: GROUP_LIST,
      };

      let list = await apiClient.get(`${UNO_URL}${fetchList[activeTab]}/${UUID}`);
      let groupDetails = await apiClient.get(`${UNO_URL}${GROUP_DETAILS}/${UUID}`);
      const tableData = exportFormatData[activeTab](list);

      await downloadExcel({
        name: exportListFileName[activeTab],
        groupName: groupDetails.name,
        heading: exportListFileName[activeTab],
        header: exportListHeaders[activeTab],
        tableData,
      });

      // await downloadPdf({
      //     mode: "landscape",
      //     groupName: groupDetails.name,
      //     heading: exportListFileName[activeTab],
      //     header: exportListHeaders[activeTab],
      //     tableData: tableData,
      // });

    } catch (error) {
      console.log(error);
    } finally {
      setPdfDownload(false);
    }
  };

  const navTabData = [
    {
      permission: GROUP_VIEW_PERMISSION,
      id: 1,
      title: "Groups",
      count: filterOptions.total[GROUP_TAB_TYPE] || null,
      key: GROUP_TAB_TYPE,
    },
    {
      permission: USER_VIEW_PERMISSION,
      id: 2,
      title: "Users",
      count: filterOptions.total[USER_TAB_TYPE] || null,
      content: null,
      key: USER_TAB_TYPE,
    },
    {
      permission: RESOURCE_VIEW_PERMISSION,
      id: 3,
      title: "Assigned Application",
      count: filterOptions.total[RESOURCE_APPLICATION_TAB] || null,
      key: APPLICATION_TAB_TYPE,
    },
  ];

  let querySearch = useDebounce(search, 500);
  let selectedGroupIds = useDebounce(groupSelectedCheckboxes, 500);
  let selectedUserIds = useDebounce(userSelectedCheckboxes, 500);

  const renderTabContent = () => {
    switch (activeTab) {
      case GROUP_TAB_TYPE:
        return (
          <GroupContent
            UUID={UUID}
            search={querySearch[activeTab]}
            selectedFilter={selectedGroupIds}
            refreshTab={refreshTab}
            isMobileView={isMobileView}
          />
        );
      case USER_TAB_TYPE:
        return (
          <UserContent
            UUID={UUID}
            search={querySearch[activeTab]}
            selectedFilter={selectedUserIds}
            refreshTab={refreshTab}
            isMobileView={isMobileView}
          />
        );
      case APPLICATION_TAB_TYPE:
        return (
          <ApplicationContent
            isMobileView={isMobileView}
            UUID={UUID}
            search={querySearch[activeTab]}
            selectedFilter={applicationSelectedCheckboxes}
            refreshTab={refreshTab}
            defaultTab={defaultTab}
            setDefaultTab={setDefaultTab}
          />
        );
      default:
        return null;
    }
  };

  const resetCheckBox = () => {
    const resetData = {
      [GROUP_TAB_TYPE]: setGroupSelectedCheckboxes,
      [USER_TAB_TYPE]: setUserSelectedCheckboxes
    }
    resetData[activeTab]?.([]);
  }

  const resetCheckApplicationTab = () => {
    setApplicationSelectedCheckboxes((prev) => ({ ...prev, [defaultTab]: [] }));
  }

  const handleOnChangeApplication = (newItem) => {
    const setters = {
      [GROUP_TAB_TYPE]: setGroupSelectedCheckboxes,
      [USER_TAB_TYPE]: setUserSelectedCheckboxes,
    };

    const setSelected = setters[activeTab];
    if (!setSelected) return;

    setSelected(prev => {
      const exists = prev.some(item => item.value === newItem.value);
      return exists ? prev.filter(item => item.value !== newItem.value) : [...prev, newItem];
    });
  };


  const handleSelectApplicationFilterCheckbox = (item, isCategory) => {
    setApplicationSelectedCheckboxes((prev) => {
      const items = prev[defaultTab];
      const [categories, tags] = [items.filter((e) => e.type === "tagCategory"), items.filter((e) => e.type !== "tagCategory")];
      const updated = isCategory ? [...tags, ...item] : [...toggleArrayByObject(tags, item), ...categories];
      return { ...prev, [defaultTab]: updated };
    });
  };

  let filterNavTab = navTabData.filter((e) => checkPermissionExist(e.permission));

  return (
    <>

      <TabNavigator
        tabs={filterNavTab}
        defaultActiveKey={activeTab}
        nav_wrapper_class="with-search"
        setActiveTab={setActiveTab}
      >
        {!isMobileView && (
          <div className="search-parent">
            <SearchBar
              onClick={() => { }}
              placeholder="Search..."
              value={search[activeTab]}
              onChange={(e) => setSearch((pre) => ({ ...pre, [activeTab]: e.target.value }))}
            />

            <div className="filterbtn" onClick={openFilter}>
              <div className="btninadjust">
                <FilterIcon />
                {((activeTab === GROUP_TAB_TYPE && groupSelectedCheckboxes.length > 0) ||
                  (activeTab === USER_TAB_TYPE && userSelectedCheckboxes.length > 0) ||
                  (activeTab === APPLICATION_TAB_TYPE && applicationSelectedCheckboxes[defaultTab]?.length > 0))
                  &&
                  <span className="filter-active-span">{""}</span>
                }
              </div>
            </div>

            {[GROUP_TAB_TYPE, USER_TAB_TYPE].includes(activeTab) && (
              <>
                <BackButton
                  onBackClick={handleClickDownload}
                  Icon={pdfDownload ?
                    <div className="loading-down"> <CircleLoading /> </div>
                    :
                    <DownloadIcon />
                  }
                />
              </>
            )}

          </div>
        )}
      </TabNavigator>

      {renderTabContent()}

      <FilterOption
        showfilter={showfilter}
        selectedCheckboxes={(activeTab === GROUP_TAB_TYPE) ? groupSelectedCheckboxes : (activeTab === USER_TAB_TYPE) ? userSelectedCheckboxes : applicationSelectedCheckboxes[defaultTab]}
        activeTab={activeTab === APPLICATION_TAB_TYPE ? defaultTab : activeTab}
        handleResetCheckBox={activeTab === APPLICATION_TAB_TYPE ? resetCheckApplicationTab : resetCheckBox}
        onToggleFilter={openFilter}
        handleSelectCheckbox={activeTab === APPLICATION_TAB_TYPE ? handleSelectApplicationFilterCheckbox : handleOnChangeApplication}
      />

    </>
  );
};

export default SectionNavigation;